var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',{attrs:{"color":"primary","colored-border":"","border":"left","icon":"mdi-information-outline","dismissible":""}},[_c('h3',{staticClass:"title"},[_vm._t("title")],2),_vm._t("content")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }